export default __webpack_public_path__ + "static/media/auteuil15.d022e670.jpg";